'use client';

import type { ReactNode } from 'react';

import { Toaster } from '@/components/ui/toaster';
import { AuthHydrator } from '@/features/auth/components/auth-hydrator';
import { QueryProvider } from '@/providers/query-provider';

interface AppProvidersProps {
  children: ReactNode;
}

export function AppProviders({ children }: AppProvidersProps) {
  return (
    <QueryProvider>
      <AuthHydrator />
      {children}
      <Toaster />
    </QueryProvider>
  );
}
